import {EditFacilityUserInput, EditFactoryUserInput, IFacility} from "../types";
import {countFactories, getAllContainedFactories} from "../Helper/FacilityAggregators";
import React, {ReactNode, useState} from "react";
import {Link} from "react-router-dom";
import {FacilityIOSummary} from "./FacilityIOSummary";
import translate from "../../translate";
import {Button, ButtonTypes} from "../../react/components/ui/spectre/buttons";
import FacilityAddEditModal from "./FacilityAddEditModal/Modal";
import {editFacility} from "../Helper/EditFacility";
import {Icon} from "../../react/components/ui/spectre/icon";
import {SatisfactoryAPI} from "../../api/FactoryGame/index";
import {useItemStackContext} from "./ItemStackContext";
import FacilityPath from "./FacilityPath";

type Props = {
    facility: IFacility,
    reload: () => Promise<void>,
    showFullRoute?: boolean,
};

export function FacilityOverview({facility, reload, showFullRoute}: Props) {
    const [ editing, setEditing ] = useState<boolean>(false);

    async function _editFacility(inputPartialFacility: EditFacilityUserInput|EditFactoryUserInput) {
        await editFacility(facility, inputPartialFacility);
        await reload();
    }

    async function deleteFacility() {
        await SatisfactoryAPI.Facility.deleteFacility(facility);
        await reload();
    }

    const totalBuildingCount = getAllContainedFactories(facility).map(factory => factory.amount).reduce((a, b) => a + b, 0);

    return <div>
        <div className='d-grid align-items-center' style={{ gridTemplateColumns: '1fr auto auto' }}>
            {!showFullRoute && <Link to={'../' + facility.id} relative="route">{facility.name || translate('react/component/Satisfactory/General/unnamedFacility')}</Link>}
            {showFullRoute && <FacilityPath facility={facility} />}
            <div>
                {totalBuildingCount}
            </div>
            <Button buttonTypes={[ButtonTypes.primary, ButtonTypes.small]} className='ml-2' onClick={() => setEditing(true)}>
                <Icon type='edit' />
            </Button>
        </div>
        <FacilityIOSummary facility={facility} />
        { editing && <FacilityAddEditModal save={_editFacility} close={() => setEditing(false)} facility={facility} delete={deleteFacility} /> }
    </div>
}
